// extracted by mini-css-extract-plugin
export default {"descriptionTemplate":"DescriptionTemplate__descriptionTemplate___kXJ5c","closeIcon":"DescriptionTemplate__closeIcon___Uyw7d"};